import { BonusPageView } from '../../view/bonus_buy/BonusBuyView';
// import { BonusReviveView } from "../../view/bonus_revive/BonusReviveView"
import { Tween, Easing } from '@tweenjs/tween.js';
import { getCurrencySymbol } from '../helper/currencies';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { isDesktop } from 'react-device-detect';
// import { getFullscreen, closeFullscreen } from "./helper/fullscreen"

class BonusWidgetController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.canBuy = !GameConfigs.doubleChance;
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
		this.bonusBuyPrice = GameConfigs.config.buyfeatureprice;
		this.currentBet = GameConfigs.currentBet;
		this.reels = GameConfigs.reelComponent;
		this.enable = false;
		if (this.vc.holder[this.config.modal]) {
			this.item = this.vc.holder.getChildByName(this.config.modal);
			if (isDesktop) {
				this.border_top = this.vc.holder.getChildByName('bg_border_top', true);
				this.border_bot = this.vc.holder.getChildByName('bg_border_bot', true);
				this.border_top.alpha = 0;
				this.border_bot.alpha = 0;
			}

			this.item.interactive = true;
			this.item.getChildByName('bg', true).cursor = 'pointer';

			this.bonus_text = this.vc.holder.getChildByName(
				'BONUS_BUY_WIDGET_TITLE',
				true
			);
			this.bonus_text.text =
				'BUY BONUS (' + GameConfigs.auth.balance.currency + ')';
			this.item.handler = this.handler.bind(this);
			this.value = this.vc.holder.getChildByName('BONUS_BUY_VALUE');
			this.setValue(this.currentBet);
			this.checkLength(this.value);
			if (GameConfigs.config.hasbuybonus) {
				this.addEventListeners();
			} else {
				this.vc.alpha = 0.5;
				this.item.handler = null;
				this.item.cursor = 'default';
				this.item.getChildByName('bg', true).cursor = 'default';
				this.item.getChildByName('bg', true).toggleEnabled(false);
			}
			window.addEventListener(EVENTS.BET_UPDATE, this, false);
		} else {
			throw new Error(
				'BonusWidgetController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	setValue(bet) {
		if (this.currency[1] === 'left') {
			this.value.text =
				this.currency[0] + (this.bonusBuyPrice * bet).toLocaleString();
		} else if (GameConfigs.auth.balance.currency === 'GEL') {
			this.value.text =
				(this.bonusBuyPrice * bet).toLocaleString() + this.currency[0];
		} else {
			this.value.text = (this.bonusBuyPrice * bet).toLocaleString();
		}
	}

	addEventListeners() {
		this.item.interactive = true;
		this.item.getChildByName('bg', true).cursor = 'pointer';
		window.addEventListener(EVENTS.ERROR_PAGE, this, false);
		window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		window.addEventListener(EVENTS.MODAL, this, false);
		window.addEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
		window.addEventListener(EVENTS.BONUS_BUY, this, false);
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			window.addEventListener('keydown', this, false);
			this.enable = true;
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.BET_UPDATE:
				this.betChanged(evt);
				break;
			case 'freespin':
				this.freespin(evt);
				break;

			case EVENTS.BONUS_ROUND_STATE:
				if (evt.detail.state === 'started') {
					window.removeEventListener(EVENTS.BONUS_BUY, this, false);
					window.removeEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
				}
				break;
			case EVENTS.BONUS_BUY:
				if (!evt.detail.bonus) {
					this.addEventListeners();
					window.addEventListener(EVENTS.BET_UPDATE, this, false);
				} else {
					this.removeListeners();
				}
				break;
			case EVENTS.ERROR_PAGE:
				if (evt.detail.error) {
					this.removeListeners();
					window.removeEventListener(EVENTS.BONUS_BUY, this, false);
					window.removeEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
				}
				break;

			case EVENTS.SETTINGS_UPDATE:
				if (window.isMobile) return;
				if (evt.detail.data.keyboard_shortcuts === undefined) return;
				if (evt.detail.data.keyboard_shortcuts) {
					if (this.enabled) return;
					this.enabled = true;
					window.addEventListener('keydown', this, false);
				} else {
					this.enabled = false;
					window.removeEventListener('keydown', this, false);
				}
				break;
			case 'keydown':
				if (evt.keyCode === 66) {
					this.handler();
				}
				break;
			case EVENTS.MODAL:
				if (!window.isMobile && !window.isTablet) return;
				if (
					evt.detail.modal === 'settings' ||
					evt.detail.modal === 'quest' ||
					evt.detail.modal === 'quest_claim' ||
					GameConfigs.bonusBuy
				) {
					this.item.interactive = false;
				} else this.item.interactive = true;
				break;
			default:
				break;
		}
	}

	betChanged(e) {
		this.currentBet = e.detail.betAmount;
		this.setValue(this.currentBet);
		// this.value.text = (this.bonusBuyPrice * bet).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
		this.checkLength(this.value);
	}

	freespin(e) {
		if (e.detail.isActive) {
			this.animateDisable();
		}
	}

	handleModal(e) {
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: e });
	}

	handler() {
		if (
			GameConfigs.doubleChance ||
			GameConfigs.bonusBuy ||
			GameConfigs.autospin.isAutoOn ||
			GameConfigs.quest_claim.step ||
			GameConfigs.isFreeSpin ||
			GameConfigs.disabled.bonus_widget ||
			GameConfigs.quest_is_active
		) {
			this.animateDisable();
			return;
		} else {
			// sound.play('buy_feature_click_sfx')
			if (GameConfigs.modal === 'bonus_buy') {
				GameConfigs.uiComponent[
					this.config.item
				].CloseController.closeHandler();
				this.handleModal('');
			} else {
				this.handleModal('bonus_buy');
				GameConfigs.uiComponent.addView(BonusPageView);
				GameConfigs.uiComponent[this.config.item].CloseController.onClose(
					() => {}
				);
			}
		}
	}
	animateDisable() {
		if (this.tween) {
			this.tween = null;
		} else {
			window.sm.play({ name: 'error_sfx' });
			this.tween = new Tween(this.vc.holder)
				.to({ x: 5 }, 10)
				.yoyo(true)
				.repeat(5)
				.easing(Easing.Linear.None)
				.start();
		}
	}

	checkLength(value) {
		if (value.text.length > 7 && value.text.length < 9) {
			value.style.fontSize = 30;
		} else if (value.text.length >= 9) {
			value.text = value.text.slice(0, 9) + '...';
			value.style.fontSize = 32;
		} else {
			value.style.fontSize = 42;
		}
	}

	removeListeners() {
		this.item.interactive = false;
		this.item.getChildByName('bg', true).cursor = 'default';
		window.removeEventListener(EVENTS.BET_UPDATE, this, false);
		window.removeEventListener(EVENTS.ERROR_PAGE, this, false);
		window.removeEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener('keydown', this, false);
	}
}

export default BonusWidgetController;
